<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="trash-2-outline"></nb-icon>
        <div class="ml-2" i18n>Deleting Insight: {{ insight.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div class="deep-delete-spinner" *ngIf="spin">
      <div></div>
    </div>
    <form #campaignForm="ngForm" *ngIf="!spin">
      <strong class="text-uppercase" i18n>Select associated objects for deletion</strong>
      <hr />

      <div class="row">
        <div class="col">
          <p style="color: green" *ngIf="affectedCampaigns.length === 0" i18n>
            No campaigns will be affected by deletion of this insight
          </p>
          <div *ngIf="affectedCampaigns.length > 0">
            <p style="color: red" *ngIf="activeCampaigns.length === 1" i18n>
              An active campaign is using this insight. Deactivate it before deleting this insight!
            </p>
            <p style="color: red" *ngIf="activeCampaigns.length > 1" i18n>
              Multiple active campaigns are using this insight. Deactivate them before deleting this insight!
            </p>
            <p style="color: orange" i18n>The following campaigns are connected to this insight:</p>
            <div *ngFor="let campaign of affectedCampaigns; index as i">
              <nb-checkbox
                id="campaign.id"
                name="deleteCampaign"
                dis
                style="padding: 3px 10px 0px 0px"
                [disabled]="campaign.status === 'ACTIVE' || campaign.status === 'RUNNING'"
                (checkedChange)="checkedChange(campaign, $event)"
              >
              </nb-checkbox>
              <label style="padding-top: 6px"
                >{{ campaign.name }} - <strong>{{ campaign.status }}</strong></label
              >
              <button nbButton size="medium" ghost status="info" (click)="viewCampaign(campaign.id)">
                <nb-icon icon="external-link-outline" nbTooltip="Open Selected Content" i18n-nbTooltip></nb-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <div class="col">
        <p i18n>Deleting the insight is <strong>irreversible</strong> and could possibly affect other campaigns.</p>
        <label i18n>Type "DELETE" to confirm deletion</label>
        <input
          id="confirmation"
          name="confirmation"
          placeholder="DELETE"
          type="string"
          class="form-control form-control-sm"
          [(ngModel)]="confirmation"
          required
          nbInput
          style="width: 100%"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        nbButton
        class="ml-3"
        status="danger"
        [disabled]="confirmation.toLowerCase() !== 'delete'"
        (click)="deepDelete()"
        i18n
      >
        Delete
      </button>
    </div>
  </nb-card-footer>
</nb-card>
